<template name = "dateTemplate" lang="html">
	<div class="row">
		<div class="content content-components bstest">
			<div class="pd-x-0 pd-lg-x-10 pd-xl-x-0">
				<div class="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
					<div>
						<nav aria-label="breadcrumb">
							<ol class="breadcrumb breadcrumb-style1 mg-b-10">
								<li class="breadcrumb-item">{{this.mainName}}</li>
								<li class="breadcrumb-item active" aria-current="page">{{this.subName}}</li>
							</ol>
							<h4 class="mg-b-0 tx-spacing--1">{{this.subName}}</h4>
						</nav>
					</div>
				</div>
				<div>
					<div class="content content-fixed">
						<div class="container pd-x-0 pd-lg-x-10 pd-xl-x-0">
							<div class="row row-xs">
								<div class="col-lg-4 col-xl-5 mg-t-10">
									<div class="card">
										<div class="card-header pd-y-20 mx-3 d-md-flex align-items-center justify-content-between">
											<h6 class="mg-b-0">Type</h6>
											<div class="d-flex justify-content-end">
												<nav id="channelNav">
													<a href="#modalInvitePeople" class="btn btn-xs pd-x-5 btn-primary btn-uppercase" data-toggle="modal" data-animation="effect-flip-horizontal">
														<feather type="plus" class="wd-15 hd-15 valign-middle-f svg_overflow"></feather>
													</a>
												</nav>
											</div>
										</div><!-- card-header -->
										<div class="card-body pos-relative pd-0">
											<table class="table" style='overflow-x:hidden'>
												<thead>
													<tr>
														<th scope="col" ><strong>code</strong></th>
														<th scope="col"><strong>Name</strong></th>
														<th></th>
													</tr>
												</thead>
												<tbody>
												<!--parent-->
													<tr v-for="(form, i) in codeHeader">
														<td class="valign-bottom-f">{{form.codecode}}</td>
														<td class="valign-bottom-f"><a href="#" v-on:click="nameClick(form.id)">{{form.codename}}</a></td>
														<td class="valign-bottom-f">
															<div v-if ="!form.flag">
																<a href="#codeUpdateModal" class="btn btn-xs pd-x-5 btn-secondary btn-uppercase" data-toggle="modal" data-animation="effect-flip-horizontal" @click="codeDataMapping(form.id,form.codename)">
																	<feather type="edit" class="wd-15 hd-15 valign-middle-f svg_overflow"></feather>
																</a>
																<a href="#" class="btn btn-xs pd-x-5 btn-secondary btn-uppercase" data-toggle="modal" data-animation="effect-flip-horizontal" @click="codeDelete(form.id)">
																	<feather type="trash-2" class="wd-15 hd-15 valign-middle-f svg_overflow"></feather>
																</a>
															</div>
														</td>
													</tr>
												</tbody>
											</table>
										</div><!-- card-body -->
									</div><!-- card -->
								</div>
								<div class="col-lg-4 col-xl-5 mg-t-10">
									<div class="card">
										<div class="card-header pd-y-20 mx-3 d-md-flex align-items-center justify-content-between">
											<h6 class="mg-b-0">Value</h6>
											<div class="d-flex justify-content-end">
												<nav id="channelNav1">
													<a href="#modalInvitePeople1"  class="btn btn-xs pd-x-5 btn-primary btn-uppercase" data-toggle="modal" data-target="#modalInvitePeople1">
														<feather type="plus" class="wd-15 hd-15 valign-middle-f svg_overflow"></feather>
													</a>
													<a href="#" class="btn btn-xs pd-x-5 btn-primary btn-uppercase" data-toggle="modal" data-animation="effect-flip-horizontal" @click="codeDetailUpdate()">
														<feather type="save" class="wd-15 hd-15 valign-middle-f svg_overflow"></feather>
													</a>
												</nav>
											</div>
										</div>
										<!--Child-->
										<div class="card-body pos-relative pd-0">
											<table class="table">
												<thead>
													<tr>
														<th scope="col"><strong>Code</strong></th>
														<th scope="col"><strong>Name</strong></th>
														<th></th>
													</tr>
												</thead>
												<tbody>
													<tr v-for="(form, i) in codeDetailHeader" v-if="form.flag">
														<td class="valign-bottom-f"><span :id='"codeCode"+i'>{{form.codeCode}}</span></td>
														<td class="valign-bottom-f">
															<input v-if="!form.editFlag" type='text' class='form-control' v-model.trim="form.codeName" :id='"codeName"+i'>
															<p v-else>{{form.codeName}}</p>
														</td>
														<td class="valign-bottom-f">
															<a v-if="!form.editFlag" href="#" class="btn btn-xs pd-x-5 btn-secondary btn-uppercase" data-toggle="modal" data-animation="effect-flip-horizontal" @click="codeDetailDelete(form.id)">
																<feather type="trash-2" class="wd-15 hd-15 valign-middle-f svg_overflow"></feather>
															</a>
														</td>
													</tr>
													<tr v-else>
														<td class="valign-bottom-f">Data does not exist.</td>
													</tr>
												</tbody>
											</table>  
										</div><!-- card-body -->
									</div><!-- card -->
								</div>
							</div><!-- row -->
						</div><!-- container -->
					</div><!-- content -->
				</div>
				<!--code detail add modal-->
				<div class="modal fade effect-scale" id="modalInvitePeople1" tabindex="-1" role="dialog" aria-hidden="true">
					<div class="modal-dialog modal-dialog-centered" role="document">
						<div class="modal-content">
							<div class="modal-body pd-20 pd-sm-30">
								<button type="button" class="close pos-absolute t-20 r-20" data-dismiss="modal" aria-label="Close">
									<span aria-hidden="true"><feather type="x" class="svg_overflow"></feather></span>
								</button>
								<div class="form-group">
									<label for="formGroupExampleInput" class="d-block">Name</label>
									<input type="text" class="form-control" ref="detailCodeNameModal" v-model.trim="detailCodeNameModal" placeholder="Name">
								</div>
								<div class="modal-footer pd-x-20 pd-b-20 pd-t-0 bd-t-0">
									<button type="button" v-on:click="addDetailCode()" class="btn btn-primary tx-13">Add</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="modal fade effect-scale" id="modalInvitePeople" tabindex="-1" role="dialog" aria-hidden="true">
				<div class="modal-dialog modal-dialog-centered" role="document">
					<div class="modal-content">
						<div class="modal-body pd-20 pd-sm-30">
							<button type="button" class="close pos-absolute t-20 r-20" data-dismiss="modal" aria-label="Close">
								<span aria-hidden="true"><feather type="x" class="wd-20 svg_overflow"></feather></span>
							</button>
							<div class="form-group">
								<label for="formGroupExampleInput" class="d-block">Name</label>
								<input type="text" id="codeNameModal" ref="codeNameModal" v-model.trim="codeNameModal" class="form-control" placeholder="Name">
							</div>
							<div class="modal-footer pd-x-20 pd-b-20 pd-t-0 bd-t-0">
								<button type="button" v-on:click="addCode()" class="btn btn-primary tx-13">Add</button>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!--code update-->
			<div class="modal fade effect-scale" id="codeUpdateModal" tabindex="-1" role="dialog" aria-hidden="true">
				<div class="modal-dialog modal-dialog-centered" role="document">
					<div class="modal-content">
						<div class="modal-body pd-20 pd-sm-30">
							<button type="button" v-on:click="dataInitialization()" class="close pos-absolute t-20 r-20" data-dismiss="modal" aria-label="Close">
								<span aria-hidden="true"><feather type="x" class="svg_overflow"></feather></span>
							</button>
							<div class="form-group">
								<label for="formGroupExampleInput" class="d-block">Name</label>
									<input type="text" id="codeName" ref="codeName" v-model.trim="codeNameUpdate" class="form-control" placeholder="Name">
							</div>
							<div class="modal-footer pd-x-20 pd-b-20 pd-t-0 bd-t-0">
								<button type="button" v-on:click="codeUpdate()" class="btn btn-primary tx-13">Update</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script src='@/assets/js/feather.min.js'></script>
<script>
	import common from '@/views/Common/common.js';
	import {bus} from '../../../main';
	export default {
		name: 'Code',
		props: ['properties'],
		components: {},
		computed: {},
		data() {
			return {
				mainName: '',
				subName: '',
				menuData: [],
				msid:'',
				mid: '',
				uid: '',

				code: '',
				codeName: '',
				codeNameModal:'',
				codeNameUpdate:'',

				codeId: '',
				codeDetailAddId: '', //codedetail insert시 codeid
				detailCode: '',
				detailCodeName: '',
				detailCodeNameModal: '',
				detailCodeNameUpdate:'',

				codeHeader:[],
				codeDetailHeader:[],
				codeData:[]
			}
		},
		beforeDestroy(){
			bus.$off('menu_data');
		},
		created() {
			bus.$on('menu_data', (data)=>{
				this.menuData = data;  
				this.classifyHeader(); 
			});
			this.mid = this.properties.mid;
			this.getCodeHeader();
		},
		mounted() {},
		methods: {
			/*
			* Load Data Default Headers
			*/
			async classifyHeader() {
				let data = common.menuHeader(this.properties.mid, this.menuData, 3);
				this.mainName = data[0];
				this.subName  = data[1];
			},
			/*
			* Code List
			*/
			async getCodeHeader() {
				await this.$axios.get(this.$apiHost + '/'+this.$route.name)
				.then(res => {
					this.codeHeader = res.data;
					for (let i in this.codeHeader) {
						if (this.codeHeader[i].codename == 'Analysis' || this.codeHeader[i].codename == 'statecode') {
							this.codeHeader[i].flag = true;
						} else {
							this.codeHeader[i].flag = false;
						}
					}
				});
			},
			/*
			* Insert Code
			*/
			async addCode() {
				if (!this.codeNameModal) {
					this.$buefy.dialog.alert({
						message: 'Please enter Code Name.',
						size: 'is-medium',
						type: 'is-danger'
					})
					this.$refs.codeNameModal.focus();//교체
					return false;
				}
				if (confirm('Would you like to register?')) {
					const codeName = this.codeNameModal;
					await this.$axios.post(this.$apiHost + '/'+this.$route.name,{codeName})
					.then(res => {
						this.$buefy.dialog.alert({
							message: res.data.message,
							size: 'is-medium',
						})
						this.getCodeHeader();
						$('#modalInvitePeople').modal('toggle');//modal exit
						this.codeNameModal = '';
					});
				} else {
					return false;
				}
			},
			/*
			* 
			*/
			async addDetailCode() { //detailCode
				if (!this.codeDetailAddId) {
					this.$buefy.dialog.alert({
						message: 'Please select a code.',
						size: 'is-medium',
						type: 'is-danger'
					})
				} else {
					if (!this.detailCodeNameModal) {
						this.$buefy.dialog.alert({
							message: 'Please enter Detail Code Name.',
							size: 'is-medium',
							type: 'is-danger'
						})
						this.$refs.detailCodeNameModal.focus();
						return false;
					}
					this.$buefy.dialog.confirm({
						message: 'Would you like to register?',
						size: 'is-medium',
						onConfirm: async () => {
							const codeName = this.detailCodeNameModal;
							const codeId = this.codeDetailAddId;
							await this.$axios.post(this.$apiHost + '/'+this.$route.name + '/detail',{codeName, codeId})
							.then(res => {
								this.getCodeHeader();
								this.nameClick(codeId);
								$('#modalInvitePeople1').modal('toggle');//modal exit
								this.codeDetailAddId = '';
								this.detailCodeNameModal = '';
							});
						},
						onCancel: () => {
							this.detailCodeNameModal = '';
							return false;
						}
					});
					
				}
			},
			/*
			* code -> detail link
			*/
			async nameClick(id) {
				this.codeDetailHeader=[];
				this.codeDetailAddId = '';
				const codeId = id;
				await this.$axios.get(this.$apiHost + '/'+this.$route.name + '/detail',{params: {codeId: codeId}})
				.then(res => {
					//this.codeDetailHeader = res.data;
					this.codeDetailAddId = id;
					let codeHeaderFlag = false;
					for (let i in this.codeHeader) {
						if (this.codeHeader[i].id == id) {
							codeHeaderFlag = this.codeHeader[i].flag;
						}
					}
					for (let i in res.data) {
						res.data[i].editFlag = codeHeaderFlag;
						this.codeDetailHeader.push(res.data[i]);
					}
					this.codeDetailHeader.sort((a, b) => {
						return Number(b.codeCode.substr(b.codeCode.length-3)) - Number(a.codeCode.substr(a.codeCode.length-3));
					})
				});
			},
		    //code delete
            async codeDelete(id) { 
                this.$buefy.dialog.confirm({
                    message: 'Would you like to delete?',
                    size: 'is-medium',
                    onConfirm: async () => {
                        await this.$axios.patch(this.$apiHost + '/' + this.$route.name + '/del',{
                            id  
                        })
                        .then(res => {
                            this.$buefy.dialog.alert({
                                message: res.data.message,
                                size: 'is-medium',
                            });
                            this.getCodeHeader();
                        });
                    },
                    onCancel: () => {
                        return false;
                    }
                });
            },
            //detail code delete
            async codeDetailDelete(id) {
                const detailCodeId = id;
                this.$buefy.dialog.confirm({
                    message: 'Would you like to delete?',
                    size: 'is-medium',
                    onConfirm: async () => {
                        await this.$axios.patch(this.$apiHost + '/'+this.$route.name + '/detail/del',{
                            id   
                        })
                        .then(res => {
                            this.$buefy.dialog.alert({
                                message: res.data.msg,
                                size: 'is-medium',
                            });
                            this.getCodeHeader();
                            this.nameClick(res.data.codeId);
                        });
                    },
                    onCancel: () => {
                        return false;
                    }
                });
            },
			/*
			* code update
			*/
			async codeUpdate() {
				this.$buefy.dialog.confirm({
					message: 'Would you like to modify?',
					size: 'is-medium',
					onConfirm: async () => {
						const id = this.codeId;
						const name = this.codeNameUpdate;

						await this.$axios.patch(this.$apiHost + '/'+this.$route.name,{id, name})
						.then(res => {
							alert(res.data.message);
							this.getCodeHeader();
							$('#codeUpdateModal').modal('toggle');
							this.dataInitialization();
						});
					},
					onCancel: () => {
						//초기화, 모달창 끄면 초기화
						this.dataInitialization();
					}
				});
			},
			/*
			* detail code update (!!codeCode 변경 진행)
			*/
			async codeDetailUpdate() {
				let idArr = [];
				for (let i in this.codeDetailHeader) {
					idArr.push({'id':this.codeDetailHeader[i].id});
				} 
				for (let i in idArr) {
					idArr[i].codeName = document.getElementById('codeName'+i).value;
				}
				this.$buefy.dialog.confirm({
					message: 'Would you like to modify?',
					size: 'is-medium',
					onConfirm: async () => {
						await this.$axios.patch(this.$apiHost + '/'+this.$route.name + '/detail',{idArr})
						.then(res => {
							alert(res.data);
						});
					},
				});
			},
			async codeDataMapping(id, name) { //수정시 데이터 전달
				this.codeId = id;
				this.codeNameUpdate = name;
			},
		
			async dataInitialization() {//수정 데이터 초기화
				this.codeId='';
				this.codeName = '';
				this.detailCodeName = '';
			}

		}
	}
</script> 

<style>
	div.bstest {
		width: 90%;
	}
	div.bstest .container td{
		width: 36%
	}
	div.bstest .container{
		max-width: 1140px;
		margin-left: 60px;
	}
	.table td {
		padding:0.8em 0.75em;
	}
</style>



// WEBPACK FOOTER //
// src/views/Management/Code/List.vue